define('vspot-angular/services/email-utils-service',[], function () {
    'use strict';


    return [function () {

        return {
            /*
             * NOTE: Entry point for validating a list of email addresses.
             *
             * Parses the name and email address for each entry.  names will precede email addresses in
             * the output array, if they are present.  the user of the output is expected to check for
             * the presence of names.
             *
             * @param emailList, goodList (Vector of EmailAddress), badList (Vector of String) can be null
             * @return void, lists populated with
             */
            cleanEmailList: function(list) {
                try
                {
                    var email, address;
                    var emails = this.cleanAndSplit(list),
                        goodList = [],
                        badList = [];
                    for (var i = 0; i < emails.length; i++)
                    {
                        email = emails[i].trim();
                        if (email !== '') {
                            try {
                                address = this.parseEmailAddress(email);
                                goodList.push(address);
                            }
                            catch (err) {
                                if (badList != null) {
                                    badList.push(email);
                                }
                            }
                        }
                    }
                }
                catch (err)
                {
                    throw new Error(err);
                }

                return { emails: goodList, errors: badList };
            },

            cleanAndSplit: function(emailList) {
                emailList = emailList.replace(/(\()/, ""); // searching for \\(
                emailList = emailList.replace(/(\))/, ""); // searching for \\)
                emailList = emailList.replace(/(\")/, ""); // searching for "
                emailList = emailList.replace("'", ""); // searching for '
                return emailList.split(/[,;\n\r]/);
            },

            parseEmailAddress: function(email) {
                // email may be embbed in <>
                var name,
                    nameSplitIdx,
                    first_name,
                    last_name;
                var emailParts = email.split(/[<>\[\]]/);

                if (emailParts.length > 1)
                {
                    name = emailParts[0].trim();
                    // split on last space; allow the user to fix it later
                    nameSplitIdx = name.lastIndexOf(' ');
                    first_name = name.substr(0, nameSplitIdx);
                    last_name = name.substr(nameSplitIdx + 1);
                    email = emailParts[1].trim();
                } else if (email.indexOf(' ') >= 0) {
                    // user tried to input a name and email, but did not put email in <..>
                    throw new Error("Email not properly formatted.");
                }

                // trim off any quotes
                if (email.charAt(0) === '"')
                {
                    email = email.substring(1, email.length() - 1);
                    email = email.trim();
                }

                if (name && name === email) {
                    //Sometimes an email program (gmail in particular) will add an address as the name of someone if it doesn't know it.
                    name = null;
                }

                // one invalid email ruins the whole bunch
                if (!this.validateEmail(email)) {
                    throw new Error("Email not properly formatted.");
                }

                return { name: name,
                         first_name: first_name,
                         last_name: last_name,
                         email: email };
            },

            validateEmail: function(email)
            {
                var isValid = true,
                    indexOfAtChar = email.indexOf("@"),
                    lastIndexOfAtChar = email.lastIndexOf("@"),
                    indexOfDotChar = email.indexOf(".", indexOfAtChar),
                    indexOfAmpersand = email.indexOf("&");

                // must be @ symbol
                if (indexOfAtChar < 0)
                {
                    isValid = false;
                }
                // no ampersand
                else if (indexOfAmpersand >= 0)
                {
                    isValid = false;
                }
                // must not be more than one @ symbol
                else if (indexOfAtChar !== lastIndexOfAtChar)
                {
                    isValid = false;
                }
                // must also be a '.' symbol
                else if (indexOfDotChar < 0)
                {
                    isValid = false;
                }

                return isValid;
            }
        };
    }];
});

